import { render, staticRenderFns } from "./zhu.vue?vue&type=template&id=5dc7a8e0&scoped=true&"
import script from "./zhu.vue?vue&type=script&lang=js&"
export * from "./zhu.vue?vue&type=script&lang=js&"
import style0 from "./zhu.vue?vue&type=style&index=0&id=5dc7a8e0&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc7a8e0",
  null
  
)

export default component.exports